
import Vue from 'vue';
import axios from 'axios';
import EventService from '@/services/EventService';
import {mapState} from 'vuex';
import {saveAs} from 'file-saver';
import store, {GetScopeFromKey} from '../store';
import Breadcrumbs from '@/components/breadcrumbs.vue';

const baseURL = EventService.ProtoURL();
const apiClient = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

type DisplayItem = {
  safetyEducationIndex: number;
  id: string;
  title: string;
  year: string;
  deadline: number;
};
export default Vue.extend({
  components: {
    Breadcrumbs,
  },
  computed: {...mapState(['user', 'currentScope'])},
  methods: {
    indexFormat: (src: number): string => {
      return EventService.getSafetyEducationIndexFormat(src);
    },
    async download() {
      if (this.user) {
        const token = await this.user.getIdToken();
        const {data} = await apiClient.get(
          `/years/docs/${this.yearOfDay}/report.docx?scope=${GetScopeFromKey(
            this.currentScope
          )}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: 'blob',
          }
        );
        saveAs(new Blob([data]), 'report.docx');
      }
    },
    async listYear() {
      this.displayItems = [];
      if (this.user) {
        const token = await this.user.getIdToken();
        const {data} = await EventService.getTrainings(
          token,
          this.yearOfDay,
          true,
          GetScopeFromKey(this.currentScope)
        );
        const ydata = await apiClient.get(`/years/range/${this.yearOfDay}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        this.start = ydata.data.start;
        // このパラメータを使っていない
        this.end = ydata.data.end;

        const datas = await Promise.all(
          data.map(async t => {
            const {data} = await apiClient.get(`/years/info/${t.id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            return data;
          })
        );

        datas
          .filter(data => data !== null)
          .map(data => {
            this.displayItems.push({
              id: data.trainingID,
              year: `${data.year}-${data.month}`,
              deadline: Number(data.month),
              title: data.title,
              safetyEducationIndex: data.safetyEducationIndex,
            });
            this.displayItems.sort((a, b) => {
              if (a.year < b.year) {
                return -1;
              }
              if (a.year > b.year) {
                return 1;
              }
              return 0;
            });
            this.companyName = data.companyName;
          });
      }
    },
  },
  props: {
    yearOfDay: String,
  },
  data: () => ({
    listItems: [],
    start: '',
    end: '',
    displayItems: [] as Array<DisplayItem>,
    selected: '',
    companyName: '',
  }),
  watch: {
    selected(index) {
      this.$router.push(
        `/detail/${this.displayItems[index].id}?year=${this.yearOfDay}`
      );
    },
    async yearOfDay() {
      await this.listYear();
    },
  },
  async mounted() {
    await this.listYear();
  },
});
